import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Noches en vela buscando cómo traducir conceptos técnicos densos a un lenguaje que tus alumnos puedan entender en el aula', 'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo', 'Alumnos desconectados que sienten que la aeronáutica técnica no tiene nada que ver con ellos ni con su futuro laboral', 'Silencios incómodos cuando un alumno pregunta la diferencia entre un motor de pistón y uno de turbina y no tenés una respuesta clara a mano', 'Fines de semana perdidos armando planificaciones, actividades y evaluaciones desde cero una y otra vez'];
  return <section className="py-20 bg-slate-950" data-id="element-271">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-273">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-274">
            ❓ ¿TE SUENA CONOCIDO ESTO?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center max-w-3xl mx-auto" data-id="element-275">
            <p className="text-[14px]" data-id="element-276">
              Domingo a las 11 de la noche. Mañana tenés clase de aerodinámica o
              planta motriz. Y todavía estás buscando cómo explicar la
              diferencia entre sustentación y resistencia, o cómo presentar el
              ciclo de un motor turbofán sin que tus alumnos se pierdan en el
              primer párrafo.
            </p>
            <p data-id="element-277">
              <strong className="text-white text-[16px]" data-id="element-278">
                No es tu culpa. Es que llevás años peleando con manuales
                técnicos en inglés de 800 páginas, documentación dispersa y
                materiales pensados para otros contextos que después tenés que
                reescribir entero para adaptarlos al aula.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-blue-950/30 border border-blue-900/50 rounded-2xl p-6 md:p-8" data-id="element-279">
          <h3 className="text-xl font-bold text-slate-200 mb-6 text-center" data-id="element-280">
            EL COSTO DE NO TENER EL MATERIAL CORRECTO
          </h3>
          <ul className="space-y-4" data-id="element-281">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-282">
                <div className="mt-1 bg-blue-500/20 p-1 rounded-full shrink-0" data-id="element-283">
                  <X className="w-4 h-4 text-blue-400" data-id="element-284" />
                </div>
                <span className="text-slate-200 font-medium text-[14px]" data-id="element-285">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-286">
          <p className="font-bold text-slate-300 text-[16px]" data-id="element-287">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
            te falta la herramienta.
          </p>
        </div>
      </div>
    </section>;
}